import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ItemType';
const ENDPOINT = `/invoice-item-types/`;

@Injectable({
    providedIn: 'root'
})
export class ItemTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
